// Basic selectors to use into slice
export const selectEditorPreviewWidgetComponentProps = (state) => {
    const widgetComponentProps = state.editor.preview?.widget?.componentProps;
    if (widgetComponentProps?.userSettings?.gridSwitch) {
        return widgetComponentProps.gridSwitcher;
    }
    return widgetComponentProps;
};
export const selectEditorPreviewWidgetComponentName = (state) => state.editor.preview?.widget?.componentName;
export const selectEditorSettingsColumnsOptions = (state) => state.editor?.settings?.data?.columns?.options;
export const selectEditorSettingsData = (state) => state.editor?.settings?.data;
export const selectEditorPreviewWidgetCompositeObjectBuilder = (state) => {
    const widgetComponentProps = state.editor.preview?.widget?.componentProps;
    if (widgetComponentProps?.userSettings?.gridSwitch) {
        return widgetComponentProps.gridSwitcher.pipelineParameter.compositeObjectBuilder;
    }
    return widgetComponentProps.pipelineParameter.compositeObjectBuilder;
};
export const selectEditorSettingsUserSettings = (state) => state.editor?.settings?.userSettings;
